import { render, staticRenderFns } from "./ServiceContacts.vue?vue&type=template&id=e42d636a&scoped=true"
import script from "./ServiceContacts.vue?vue&type=script&lang=ts"
export * from "./ServiceContacts.vue?vue&type=script&lang=ts"
import style0 from "./ServiceContacts.vue?vue&type=style&index=0&id=e42d636a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42d636a",
  null
  
)

export default component.exports